import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class ECSIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 179.91 300">
                <path
                    d="M117.13 0H62.77A62.78 62.78 0 0 0-.05 62.77v145.89a62.76 62.76 0 0 0 61.2 62.73v22.79a5.81 5.81 0 0 0 5.81 5.81h45.87a5.81 5.81 0 0 0 5.81-5.81V271.4a62.76 62.76 0 0 0 61.31-62.73V62.77A62.78 62.78 0 0 0 117.13 0z"
                    fill={color}
                />
                <path
                    d="M97.95 102c-2-2.94-3.76-5.64-5.41-8.11a3.58 3.58 0 0 0-.94-.94 3.06 3.06 0 0 0-4.23.94c-1.53 2.47-3.29 5.06-5.41 8.11-9.29 13.64-23.16 34.21-23.16 46a31 31 0 0 0 9.17 22 31.41 31.41 0 0 0 21.98 9 31.31 31.31 0 0 0 31.16-31.16c0-11.76-13.88-32.22-23.16-45.84zm10.54 57.37a20.9 20.9 0 0 1-7.75 7.5 3.55 3.55 0 0 1-1.78.48 3.61 3.61 0 0 1-.94-.12 3.93 3.93 0 0 1-2.39-1.89 3.5 3.5 0 0 1-.31-2.78 3.83 3.83 0 0 1 1.72-2.21 13.7 13.7 0 0 0 5.18-5 14.5 14.5 0 0 0 2.14-6.86 3.71 3.71 0 0 1 1.23-2.52 3.48 3.48 0 0 1 2.64-.91 3.7 3.7 0 0 1 2.51 1.23 3.54 3.54 0 0 1 .91 2.64 20.55 20.55 0 0 1-3.17 10.42z"
                    fill={secondaryColor}
                />
            </svg>
        );
    }
}

export default withTheme(ECSIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/ECSIcon.js